<template>
  <!--h4 class="text-success text-center">Api integrated</h4-->
  <div class="px-4">
    <div class="mb-3">
      <BreadcrumbNav />
    </div>

    <div class="card shadow-sm border-0">
      <div class="card-header text-white">
        <h5 class="mb-0">Add New Skill</h5>
      </div>
      <div class="card-body w-50 mx-auto">
        <form @submit.prevent="submitForm">
          <!-- Name Field -->
          <div class="mb-3">
            <label for="name" class="form-label">Name</label>
            <input type="text" id="name" v-model="form.name" class="form-control border border-gray px-2"
              placeholder="Enter skill name" required />
          </div>

          <!-- Description Field -->
          <div class="mb-3">
            <label for="description" class="form-label">Description</label>
            <textarea id="description" v-model="form.description" class="form-control border border-gray px-2"
              placeholder="Enter skill description" rows="3"></textarea>
          </div>

          <!-- Actions -->
          <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-secondary me-2" @click="resetForm">
              Reset
            </button>
            <button type="submit" :disabled="isSaving" class="btn btn-success btn-sm">
              <span v-if="isSaving" class="spinner-border spinner-border-sm me-2" role="status"
                aria-hidden="true"></span>
              <i v-else class="material-icons text-lg me-1">save</i>
              {{ isSaving ? 'Saving...' : 'Save Skill' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import BreadcrumbNav from '../../components/common/BreadcrumbNav.vue';
import { useBreadcrumb } from '@/composables/useBreadcrumb';

const router = useRouter();
const route = useRoute();
const store = useStore();
const toast = useToast();
const { trail, setTrail } = useBreadcrumb();
const isSaving = ref(false);

// Fallback trail for direct-URL access
if (!trail.value.length) {
    setTrail([
        { label: 'Skills', icon: 'workspace_premium', route: { name: 'skills', params: { locationid: route.params.locationid } } },
        { label: 'Create Skill', icon: 'add' },
    ]);
}

const form = reactive({
  name: '',
  description: '',
});

const submitForm = async () => {
  isSaving.value = true;

  try {
    if (!form.name) {
      toast.error('Name is required!', { position: 'top-right' });
      return;
    }
    const newSkill = await store.dispatch('createSkill', {
      skillname: form.name,
      description: form.description,
      locationid: route.params.locationid,
      is_default: false,
      interest_auto_add: false,
      publicview: true,
      preselect: false,
    });

    if (newSkill) {
      toast.success(newSkill.message || 'Skill created successfully!', { position: 'top-right' });
      // Replace Create Skill crumb with the new skill name
      setTrail([
          { label: 'Skills', icon: 'workspace_premium', route: { name: 'skills', params: { locationid: route.params.locationid } } },
          { label: form.name || 'New Skill', icon: 'workspace_premium' },
      ]);
      router.push({ name: 'editSkill', params: { locationId: route.params.locationid, skillid: newSkill.output.skillid } });
    }

    resetForm();
  }
  finally {
    isSaving.value = false;
  }
};

const resetForm = () => {
  form.name = '';
  form.description = '';
};
</script>